// Phase 2 — AI Discovery questionnaire definition.
// Four grouped steps so the visitor never sees more than ~3 inputs at once.

export const VISITOR_TYPES = [
  { id: "prime",       label: "Prime contractor" },
  { id: "sub",         label: "Subcontractor" },
  { id: "consultant",  label: "Capture / proposal consultant" },
  { id: "agency",      label: "Federal agency / buyer" },
  { id: "other",       label: "Other" },
];

export const CATEGORIES = [
  { id: "sdvosb",   label: "SDVOSB" },
  { id: "vosb",     label: "VOSB" },
  { id: "8a",       label: "8(a)" },
  { id: "wosb",     label: "WOSB" },
  { id: "hubzone",  label: "HUBZone" },
  { id: "sb",       label: "Small business" },
  { id: "large",    label: "Large business" },
  { id: "none",     label: "None of these" },
  { id: "other",    label: "Other" },
];

export const CHALLENGES = [
  { id: "find_opps",       label: "Finding opportunities" },
  { id: "choose_bids",     label: "Choosing what to bid (bid/no-bid)" },
  { id: "competitors",     label: "Understanding competitors" },
  { id: "teaming",         label: "Finding teaming partners" },
  { id: "proposals",       label: "Writing proposals" },
  { id: "pipeline",        label: "Managing capture pipeline" },
  { id: "agency_patterns", label: "Understanding agency buying patterns" },
  { id: "pricing",         label: "Pricing strategy" },
  { id: "compliance",      label: "Compliance review" },
];

export const BID_VOLUMES = [
  { id: "0-5",   label: "0–5 / year" },
  { id: "5-25",  label: "5–25 / year" },
  { id: "25-75", label: "25–75 / year" },
  { id: "75+",   label: "More than 75 / year" },
];

export const CONTRACT_SIZES = [
  { id: "<100k",      label: "Under $100K" },
  { id: "100k-1m",    label: "$100K – $1M" },
  { id: "1m-10m",     label: "$1M – $10M" },
  { id: "10m-50m",    label: "$10M – $50M" },
  { id: "50m+",       label: "$50M+" },
];

export const TOOLS = [
  { id: "nothing",      label: "Nothing yet" },
  { id: "spreadsheet",  label: "Spreadsheets" },
  { id: "crm",          label: "A CRM (Salesforce / HubSpot / etc.)" },
  { id: "capture",      label: "A capture tool (GovWin / Bloomberg / etc.)" },
  { id: "proposal",     label: "A proposal tool (Privia / Virtual / etc.)" },
  { id: "mix",          label: "A mix of the above" },
];

export const ENGAGEMENTS = [
  { id: "self",       label: "Self-service AI tools" },
  { id: "with_you",   label: "Done-with-you strategy" },
  { id: "full",       label: "Full-service support" },
  { id: "unsure",     label: "Not sure yet" },
];

export const STEPS = [
  {
    key: "who",
    title: "Tell us who you are.",
    fields: [
      { id: "visitor_type", label: "I am a…",        kind: "single",   options: VISITOR_TYPES, required: true },
      { id: "categories",   label: "Which apply?",    kind: "multi",    options: CATEGORIES,    required: false },
    ],
  },
  {
    key: "shape",
    title: "What's your pipeline shape?",
    fields: [
      { id: "bid_volume",    label: "How many bids do you pursue per year?", kind: "single", options: BID_VOLUMES,    required: true },
      { id: "contract_size", label: "Typical contract size?",                kind: "single", options: CONTRACT_SIZES, required: false },
      { id: "focus",         label: "Industries, NAICS codes, or agencies (optional)", kind: "text", placeholder: "e.g. 541512, DoD Army, cyber, EHR…", required: false },
    ],
  },
  {
    key: "struggle",
    title: "What slows you down the most?",
    fields: [
      { id: "challenges", label: "Pick all that apply (1–3 ideal)", kind: "multi", options: CHALLENGES, required: true, max: 4 },
      { id: "tools",      label: "What do you use today?",          kind: "single", options: TOOLS,    required: false },
    ],
  },
  {
    key: "fit",
    title: "How would you prefer to work with us?",
    fields: [
      { id: "engagement", label: "Preference", kind: "single", options: ENGAGEMENTS, required: false },
    ],
  },
];
